import React, { useState, useEffect } from 'react'
import {useSearchParams, useParams } from 'react-router-dom';
import Steps from '../../Components/Customer/Inspection/Steps'
import Calendar from '../../Components/Calendar'
import Payment from '../../Components/Customer/Payment'
import Confirm from '../../Components/Customer/Inspection/Confirm'
import erpAxios from '../../api/ErpAxios'; 
import dayjs from "dayjs";
import Loader from '../../Components/Loader'
import PropertyList from '../../Components/Customer/PropertyList'
import SubHeader from '../../Components/Customer/SubHeader';
import Header from '../../Components/Customer/Header';
import Login from '../../Components/Customer/Login';
import useToken from '../../Components/Customer/useToken';
import useAccount from '../../Components/Customer/useAccount';
import { useNavigate } from "react-router-dom";
import Options from '../../Components/Customer/Inspection/Options';
import AddProperty from '../../Components/Customer/AddProperty';
function Inspection(props) {
  let navigate = useNavigate();
  const handleTerms = () => {
    navigate("/terms");
  }
  // const query = new URLSearchParams(window.location.search);
  const { service_type } = useParams();
  const [serviceType, setServiceType] = useState(service_type || 'ac-qd');
  const [areaofService, setAreaofService] = useState(props.areaofService ? props.areaofService : 'both');
  const [searchParams, setSearchParams] = useSearchParams();
  const [paymentReference, setPaymentReference] = useState()
  const [activeStep, setActiveStep] = useState(2)
  const { account, setAccount } = useAccount();
  const { token, setToken } = useToken();
  const [showProperties, setShowProperties] = useState(false);
  
  const steps = [
    {
      label: 'Service',
      step: 1,
    },
    {
      label: 'Booking',
      step: 2,
    },
    {
      label: 'Options',
      step: 3,
    },
    {
      label: 'Confirm',
      step: 4,
    },
  ]

  const logout = () => {
    setToken('')
    setAccount('')
   sessionStorage.removeItem("token");
   sessionStorage.removeItem("account_details");
}

  if (paymentReference) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    document.body.style.overflow = 'hidden';
 } else if (activeStep === 1 && !props.showProperties && !props.showNewProperty) {
    document.body.style.overflow = 'unset';
  } 

  const nextStep = () => {
    if (selectedDate) {
      setActiveStep(activeStep + 1)
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      document.body.style.overflow = 'hidden';
      console.log(selectedDate)
    }

  }


 
  const prevStep = () => {
    setActiveStep(activeStep - 1)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    document.body.style.overflow = 'unset';
  }

  const backToHomePage = () => {
    setActiveStep(2)
    setLoading(false);
    setError(false);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    document.body.style.overflow = 'unset';
    if (searchParams.has('reference_uuid')) {
      searchParams.delete('reference_uuid');
      setSearchParams(searchParams);
    }
  }

  const totalSteps = steps.length

  const BASE_URL = '/calendar/inspections';
  const [properties, setProperties] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(dayjs().format('MM'));
  const [currentYear, setCurrentYear] = useState(dayjs().format('YYYY'));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);  
  const [fetchTime, setFetchTime] = useState(Date.now());
  const [selectedInspection, setSelectedInspection] = useState();
  const [bookedInspections, setBookedInspections] = useState(null);
 
  const handleUndoSelectedInspection = () => {
    setSelectedInspection(null);
  };

  const handleModifyInspection = (booking) => {
    setSelectedInspection(booking);
    console.log('Selected booking:', booking);
  };

 


  useEffect(() => {
    if(account){
    const intervalId = setInterval(() => {
      const currentTime = Date.now();
      const timeDiff = currentTime - fetchTime;
      if (timeDiff >= 5 * 60 * 1000) { // 5 minutes
        setFetchTime(currentTime);
        fetchData(currentMonth, currentYear, account.primary_property_id, serviceType,areaofService);
      }
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(intervalId);
  }

  }, [currentMonth, currentYear, account, serviceType,areaofService]);

  const fetchData = async (month, year, propertyId, serviceType,areaofService) => {
    try {
      setProperties(null);
      setLoading(true);
      setError(error);
      if(propertyId){ 
        await erpAxios.get(BASE_URL, {
        params: {
          property_id: propertyId,
          month: month,
          year: year,
          service_type: serviceType,
          area_of_service: areaofService,
        }
      })
        .then(response => {
          setProperties(eval(response.data));
          setLoading(false);
          setError(false);
        })
        .catch((error) => {
          console.log(error);
          setProperties(null);
          setLoading(false);
          setError(true);
        })

      }else{
        
        console.log('No primary property ID found for the account.');
      }
      

        

    } catch (error) {
      console.log(error);
    }

  };
  useEffect(() => {
    if(account){
  // console.log('Fetching data for property ID:', account.primary_property_id);
  if(account.primary_property_id){
fetchData(currentMonth, currentYear, account.primary_property_id, serviceType,areaofService);
  }
    
    if (searchParams.has('reference_uuid')) {
        setPaymentReference(searchParams.get('reference_uuid'))
    }else{
      setPaymentReference()
    }
  }
  }, [account, searchParams]);

  const handlePropertyChange = (propertyId) => {
    console.log('Selected property ID:', propertyId);
    setShowProperties(false);
    setShowNewProperty(false);
    const newPrimaryPropertyAddress = account.properties[propertyId];
  setAccount({ ...account, primary_property_id: propertyId, primary_property_address: newPrimaryPropertyAddress });

  console.log('Updated account:', account);
    fetchData(currentMonth, currentYear, propertyId, serviceType, areaofService)
  };


  const handleNewProperty = (propertyId) => {
    setShowProperties(false);
    setShowNewProperty(false);
    fetchData(currentMonth, currentYear, propertyId, serviceType, areaofService)
  }


  const changeServiceType = (type) => {
    setServiceType(type);
    setAreaofService('both');
    setActiveStep(2)
    setSelectedDate(null)
    setSelectedTimeSlot(null)
    setSelectedInspection(null);
    setPaymentReference(null);
    fetchData(currentMonth, currentYear, account.primary_property_id, type, areaofService);
  }

  const changAareaofService = (area) => {
    console.log('Selected area:', area);
    setAreaofService(area);
    setActiveStep(2)
    setSelectedDate(null)
    setSelectedTimeSlot(null)
    setSelectedInspection(null);
    setPaymentReference(null);
    fetchData(currentMonth, currentYear, account.primary_property_id, serviceType, area);
  }

  const handleDayClick = (day) => {
    setSelectedDate(day)
    setSelectedTimeSlot(null)
  };


  const handleMonthNavClick =(month, year) => {
    setCurrentMonth(month)
    setCurrentYear(year)
    fetchData(month, year, account.primary_property_id, serviceType,areaofService)
  }

  const handlePropertyOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      setShowProperties(false);
    }
  };
  const handleNewPropertyOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      setShowNewProperty(false);
    }
  };
  
  const handleOptionOverlayClick = (event) => {
    if (event.target === event.currentTarget)
    prevStep();
  };
  
  const handleConfirmOverlayClick = (event) => {
    if (event.target === event.currentTarget)
    backToHomePage();
  };

  const handleConfirmInspection = (time) => {
    setSelectedTimeSlot(time);
    setActiveStep(4)
  };

  const handleCloseNewProperty = () => {
    setShowNewProperty(false);
    document.body.style.overflow = 'unset';
  };
 

// --- Redirect to home if serviceType is not in globalServiceTypes ---
useEffect(() => {
  if (serviceType && props.globalServiceTypes) {
    const validKeys = props.globalServiceTypes.map(s => s.key);
    if (!validKeys.includes(serviceType)) {
      navigate("/inspection");
    }
  }
}, [serviceType, props.globalServiceTypes, navigate]);



  //New Property: Begin 
const [showNewProperty, setShowNewProperty] = useState(false);
   const newPropertyClick = () => {
    setShowNewProperty(true);
     window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      document.body.style.overflow = 'hidden';
  }

  //New Property: End
  
  if(!token || !account) {
    return <Login setToken={setToken} setAccount={setAccount}  />
  }
 
  return (
    
    <div className="">

    <Header  clickLogout={logout} 
     serviceType={serviceType}
     globalServiceTypes={props.globalServiceTypes}
     setServiceType={changeServiceType}
     account={account}
     type="inspection"
     />
    
    <SubHeader account = {account} 
      setShowProperties={setShowProperties} 
      setShowNewProperty={newPropertyClick}
      serviceType={serviceType}
      key={account.primary_property_id} />

{(loading) && <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"><Loader /></div>}
   

      {/* Step Begin */}
      <section id="header-section" className=" bg-slate sm:max-w-full">
        <div className="container mx-auto  px-4">

          <Steps selected={activeStep}
          selectedInspection={selectedInspection} 
          serviceType={serviceType}
          globalServiceTypes={props.globalServiceTypes}
          areaofService={areaofService}
          setAreaofService={changAareaofService}
          items={steps}
          undoSelectedInspection={handleUndoSelectedInspection}
           />
        </div>
      </section>
      {/* Step End */}

      {/* Calendar Begin */}
      <section id="calendar-section" className=" bg-slate sm:max-w-full">
        <div className="container mx-auto  px-4">

 <Calendar currentMonth={currentMonth}
            currentYear={currentYear}
            items={properties}
            onSearch={(month, year) => handleMonthNavClick(month, year)}
            onDaySelect={handleDayClick}
            selectedDate={selectedDate}
            bookedServices={bookedInspections}
            selectedBooking={selectedInspection} 
            selectedPropertyId={account.primary_property_id}
            type="inspection"
          />

        </div>
      </section>
      {/* Calendar End */}

     

        {/* Properties Begin */}
<section id="property-section" className={`${showProperties ? '' : 'hidden'} sm:max-w-full`}>
<div className="bg-white/10 w-screen h-screen inset-0 absolute top-0 left-0 backdrop-blur-sm" onClick={handlePropertyOverlayClick}></div>
        <div className="flex absolute top-44 left-0 right-0 h-auto items-center justify-center">
        <div className="w-96 bg-white  rounded gap-1 shadow-2xl shadow-primary/20 mx-auto py-5 px-8">
      <PropertyList 
        visible={showProperties} 
        setVisible={setShowProperties} 
        properties={account.properties} 
        handlePropertyChange={handlePropertyChange}
        onClose={() => setShowProperties(false)}
        selectedPropertyId={account.primary_property_id}
         setShowNewProperty={newPropertyClick}
        account={account}
      />
    </div>
  </div>
</section>
{/* Properties End */}

 {/* New Property Begin */}
<section id="property-section" className={`${showNewProperty ? '' : 'hidden'} sm:max-w-full`}>
    <div className="bg-white/50 w-screen h-screen inset-0 absolute top-0 left-0 backdrop-blur-sm"></div>
        <div className="flex absolute inset-0 h-screen w-screen items-center" 
        onClick={handleNewPropertyOverlayClick}>
          <div className="md:w-96 w-54 bg-white  rounded gap-1 shadow-2xl shadow-primary/20 mx-auto py-5 px-8">
            <AddProperty
              primaryPropertyAddress={account.primary_property_address}
              onClose={handleCloseNewProperty}
              handlePropertyChange={handleNewProperty}
              account={account}
            />

          </div>
        </div>
</section>
{/* New Property End */}

      {/* Options Begin */}
      <section id="option-section" className={`${activeStep === 3 ? "" : "hidden"}`}>
        <div className="bg-white/50 w-screen h-screen inset-0 absolute top-0 left-0 backdrop-blur-sm"></div>
        <div className="flex absolute inset-0 h-screen w-screen items-center" 
        onClick={handleOptionOverlayClick}>
          <div className="md:w-96 w-54 bg-white  rounded gap-1 shadow-2xl shadow-primary/20 mx-auto py-5 px-8">
            <Options
              serviceType={serviceType}
              globalServiceTypes={props.globalServiceTypes}
              areaofService={areaofService}
              primaryPropertyAddress={account.primary_property_address}
              doPreviousStep={prevStep}
              nextStep={(time) => handleConfirmInspection(time)}
              items={properties}
              selectedDate={selectedDate}
              selectedInspection={selectedInspection}
              account={account}
            />

          </div>
        </div>
      </section>
      {/* Options End */}

      {/* Confirm Begin */}
      <section id="confirm-section"  className={`${activeStep === 4 ? "" : "hidden"}`}>
        <div className="bg-white/50 w-screen h-screen inset-0 absolute top-0 left-0 backdrop-blur-sm"></div>
        <div className="flex absolute inset-0 h-screen w-screen items-center" 
        onClick={handleConfirmOverlayClick}>
          <div className="md:w-96 w-54 bg-white  rounded gap-1 shadow-2xl shadow-primary/20 md:mx-auto mx-9 md:py-5 md:px-8 px-5 py-4">
            <Confirm
              serviceType={serviceType}
              globalServiceTypes={props.globalServiceTypes}
              areaofService={areaofService}
              primaryPropertyAddress={account.primary_property_address}
              selectedDate={selectedDate}
              selectedTimeSlot={selectedTimeSlot}
              selectedInspection={selectedInspection}
              account={account}
              goBackToHomePage={backToHomePage} />
          </div>
        </div>
      </section>
      {/* Confirm End */}

      



  


      <section id="button-section" className=" bg-slate">
        <div className="container mx-auto md:px-4 px-8">
          <div className="pb-14">
            <p className="pb-7 md:text-sm text-xs text-primary/70 md:text-left text-center">
            By proceeding with a inspection on the Saniservice Booking website, you acknowledge that you have read, understood, and agree to these 
            <span className='text-danger ml-1 cursor-pointer underline' onClick={handleTerms}>terms and conditions.</span>
            </p>

            <div className={`flex justify-center md:block ${(activeStep > 1 && activeStep < totalSteps) ? 'flex justify-between' : (activeStep === totalSteps) ? 'md:text-left' : 'md:text-right'} `}>

              {/* <button
                onClick={prevStep}
                className={`text-white text-2xl font-bold py-3.5 px-32 rounded bg-danger hover:bg-danger/80
            ${activeStep === 1 ? 'hidden' : ''}
            `}>
                Previous
              </button> */}

              <button
  onClick={nextStep}
  className={`text-white md:text-2xl text-md font-bold py-2 md:py-3.5 px-32 rounded 
    ${activeStep === totalSteps ? 'hidden' : ''}
    ${selectedDate ? "bg-danger hover:bg-danger/80" : 'bg-danger/50 cursor-not-allowed'}
    flex justify-center md:inline-block
  `}
>
  Continue
</button>
            </div>
          </div>
        </div>
      </section>




    </div>

  )
}

export default Inspection